import React from 'react';
import { Helmet } from 'react-helmet';
import styles from '../css/Main.css';

import photo from '../../design/photos/objekte/Ruoff_091117_0077_w.jpg';

export default function App(props) {
  return (
    <div className={styles.body}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Hanna Schneider</title>
        <link rel="icon" href={photo} />
      </Helmet>
      {props.children}
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/pages/App.js